import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import ManageExaminees from 'assets/svgs/manageExaminees.svg';
import { AlertNotice } from 'shared/components';
import { isWindowEvent } from 'shared/helpers';

import './TcEventRoster.scss';

const transform = (listOfOptions) => {
  const newList = [];
  listOfOptions.forEach((option) => {
    newList.push({
      label: `${option.name}${option.area && option.area.length > 0 && `, ${option.area}`}`,
      key: 'location' + option.id,
      value: option.locationEvent.id,
      name: 'location' + option.id,
    });
  });
  return newList;
};

//check if date is over 7 days past
export const is7DaysPastEvent = (assignmentDate, serverDateTime) => {
  const currentDate = moment(serverDateTime);

  return moment(assignmentDate).add(7, 'd').isBefore(currentDate, 'day');
};

//check date availability
//roster available - if current date is same or after rosterStartDate and 7 days after the test event date(reschedule date)
export const checkDate = (eventDate, rosterStartDate, serverDateTime) => {
  const currentDate = moment(serverDateTime);

  return (
    (currentDate.isSameOrAfter(moment(rosterStartDate), 'day') &&
      currentDate.isSameOrBefore(moment(eventDate), 'day')) ||
    (!is7DaysPastEvent(eventDate, serverDateTime) && currentDate.isAfter(moment(eventDate), 'day'))
  );
};

class TcEventRoster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      radioListLocations: transform(props.locations) || [],
    };

    this.goToManageRoster = this.goToManageRoster.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.locations.length &&
      !this.state.radioListLocations.length &&
      prevProps.locations !== this.props.locations
    ) {
      this.setState({
        radioListLocations: transform(this.props.locations),
      });
    }
  }

  goToManageRoster() {
    this.props.history.push(
      `/test-event/${this.props.tcEvent.id}/rosters/${this.props.tcEvent.locationEvents[0].id}`
    );
  }

  render() {
    const { tcEvent, serverDateTime } = this.props;
    const eventDate = isWindowEvent(tcEvent.testingEvent)
      ? tcEvent.testingEvent.endTestDate
      : tcEvent.testingEvent.testDate;
    const infoMessage = is7DaysPastEvent(tcEvent.rescheduleDate || eventDate, serverDateTime)
      ? this.props.t('testCenter.eventDashboard.rosterUnavailableMessage')
      : this.props.t('testCenter.eventDashboard.rosterAvailableMessage', {
          date: moment(tcEvent.testingEvent.rosterStartDate).format('MM.DD.YYYY'),
        });

    return (
      <div className="">
        {tcEvent &&
        serverDateTime &&
        checkDate(
          tcEvent.rescheduleDate || eventDate,
          tcEvent.testingEvent.rosterStartDate,
          serverDateTime
        ) ? (
          <div className="tc-event-rosters">
            <button
              className="btn-link btn-roster fw-bold pt-3 svg-right"
              onClick={this.goToManageRoster}>
              <ManageExaminees />
              {this.props.t('testCenter.eventDashboard.rosterTitle')}
            </button>
          </div>
        ) : (
          <AlertNotice message={infoMessage} />
        )}
      </div>
    );
  }
}

TcEventRoster.propTypes = {
  tcEvent: PropTypes.shape({}).isRequired,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      rooms: PropTypes.arrayOf(PropTypes.shape({})),
    })
  ).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TcEventRoster);
